import React from 'react';
import { Share2, LogIn, FilePlus2 } from 'lucide-react';

/** Referral path — no OPD patient-category / non-dependent options. */
export default function BookingReferralRedirect({ primary, onBack }) {
  const inPortal = typeof window !== 'undefined'
    && window.location.pathname.startsWith('/patient');

  return (
    <div className="rounded-2xl border border-white/12 bg-white/[0.04] p-5 space-y-4" data-testid="booking-referral-redirect">
      <div className="flex items-start gap-3">
        <div
          className="h-10 w-10 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: `${primary}22`, color: primary }}
        >
          <Share2 className="h-5 w-5" />
        </div>
        <div>
          <p className="text-sm font-semibold text-zinc-100">Specialist referral</p>
          <p className="text-[12px] text-zinc-400 mt-1 leading-relaxed">
            {inPortal
              ? 'Continue in the patient portal to request a specialist referral letter from a campus doctor.'
              : 'Referrals are not booked as OPD slots here. Sign in to the patient portal to request a specialist referral letter.'}
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {inPortal ? (
          <a
            href="/patient/referrals/new"
            className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-semibold text-white"
            style={{ background: primary }}
          >
            <FilePlus2 className="h-3.5 w-3.5" /> Request referral
          </a>
        ) : (
          <a
            href="/login"
            className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-semibold text-white"
            style={{ background: primary }}
          >
            <LogIn className="h-3.5 w-3.5" /> Sign in for referrals
          </a>
        )}
      </div>
      {onBack ? (
        <button type="button" onClick={onBack} className="text-[11px] text-zinc-500 hover:text-zinc-300">
          ← Back — book an OPD consultation instead
        </button>
      ) : null}
    </div>
  );
}
